export const links = [
  { link: '/features', label: 'امکانات' },
  { link: '/store-examples', label: 'نمونه فروشگاه‌ها' },
  { link: '/instagram-shop', label: 'فروش از اینستاگرام' },
  { link: '/pricing', label: 'تعرفه‌ها' },
  { link: process.env.NEXT_PUBLIC_WITRO_URL, label: 'ویتروشاپ' },
  { link: '/contact', label: 'ارتباط با ما' },
];
